import React from 'react';
import WhatsThis from '../controls/whatsThis';
const FullTextSearchInstructions = () => {
  const dtStyle = {
    float: 'left'
  };
  const ddStyle = {
    float: 'left',
    textAlign: 'left'
  };
  const searchHelperText = /*#__PURE__*/React.createElement("dl", {
    style: {
      padding: '5px'
    }
  }, /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Find part of a name or ID"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Type at least 3 letters or numbers. For example, 1234 finds any name or ID that includes 1234."), /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Search for more than one word"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Search normally finds results with all of your words. Use the gear to match any of them. Very common words are ignored."), /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Find one exact value"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Choose Exact under the gear when you know the complete name or ID. Symbols like an asterisk are searched for just as you type them."));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      paddingRight: '5px'
    }
  }, "Search Help"), /*#__PURE__*/React.createElement(WhatsThis, {
    text: searchHelperText,
    title: "Search Options"
  }));
};
export default FullTextSearchInstructions;